import { vec2 } from 'gl-matrix';
import { WindowLevel } from '../patient/windowLevel';
import { BaseDomainEvent } from './DomainEvent';
import { EventSource } from './EventTypes';

/**
 * Domain event emitted when {@link WindowLevel} is adjusted by a delta.
 */
export class WindowLevelDeltaEvent extends BaseDomainEvent {
    static readonly EVENT_TYPE = 'WINDOW_LEVEL_DELTA';

    constructor(delta: vec2, seriesUid: string, source: EventSource = 'user') {
        super(WindowLevelDeltaEvent.EVENT_TYPE, seriesUid, {
            delta: [delta[0], delta[1]],
            seriesUid,
            source,
        });
    }

    get delta(): vec2 {
        return this.data.delta as vec2;
    }

    get seriesUid(): string {
        return this.data.seriesUid;
    }

    get source(): EventSource {
        return this.data.source;
    }
}

/**
 * Domain event emitted when {@link WindowLevel} is set to a specific value.
 */
export class WindowLevelSetEvent extends BaseDomainEvent {
    static readonly EVENT_TYPE = 'WINDOW_LEVEL_SET';

    constructor(
        windowLevel: WindowLevel,
        seriesUid: string,
        source: EventSource = 'user'
    ) {
        super(WindowLevelSetEvent.EVENT_TYPE, seriesUid, {
            window: windowLevel.window,
            level: windowLevel.level,
            minLevel: windowLevel.minLevel,
            maxLevel: windowLevel.maxLevel,
            seriesUid,
            source,
        });
    }

    get windowLevel(): WindowLevel {
        return new WindowLevel(
            this.data.window,
            this.data.level,
            this.data.minLevel,
            this.data.maxLevel
        );
    }

    get seriesUid(): string {
        return this.data.seriesUid;
    }

    get source(): EventSource {
        return this.data.source;
    }
}
